import * as React from 'react';
import { connect } from 'react-redux';
import { RouteComponentProps } from 'react-router';
import * as PhoneParser from 'libphonenumber-js/max'
import AccountAttachForm from './forms/AccountAttachForm';
import Navigation from '../../../constants/enums/NavigationEnum'
import { NotificationTypeEnum, NotificationToast } from '../../../models/NotificationModels'
import { ServiceObjectTypeNumber, ServiceObjectTypeAttachAccount } from '../../../models/SettingModels'
import {  CreateMainContactCommand } from '../../../models/ClientManagerModels'
import { AttachPersonalAccountCommand } from '../../../models/AccountModels'
import { ToastNotificationManager } from '../../../infrastructure/ToastNotificationManager'
import { ApiResponseHelper } from '../../../infrastructure/utils/ApiResponseHelper'
import { AccountManagerRequests } from '../../../apiRequests/AccountManagerRequests';
import { SettingRequests } from '../../../apiRequests/SettingRequests';
import { ApplicationState } from '../../../store';
import * as AccountStore from '../../../store/AccountStore';
import { Modal, Popup } from '../../components/Modals';
import CloseIcon from '../../../images/dynamicIcons/closeIcon';


const dispatchAction = {
    AttachAccountAction: AccountStore.actionCreators.AddAttachedAccountAction,
    SetAttachOpen: AccountStore.actionCreators.SetAttachOpen
}

type AccountAttachProps = RouteComponentProps<{}> &
{ attachIsOpen: boolean } &
    typeof dispatchAction


interface AccountAttachState {
    isLoading: boolean,
    isProgress: boolean,
    isAttach: boolean,
    isExistsMainContact: boolean | null,
    serviceObjectTypeNumber: ServiceObjectTypeNumber | null;
    serviceObjectTypeAttachAccount: ServiceObjectTypeAttachAccount | null;
    successIsOpen: boolean;
    errorMessage: string;

}


class AccountAttach extends React.PureComponent<AccountAttachProps, AccountAttachState> {

    constructor(props: AccountAttachProps) {
        super(props);
        this.state = {
            isLoading: false,
            isProgress: false,
            isAttach: false,
            isExistsMainContact: null,
            serviceObjectTypeNumber: null,
            serviceObjectTypeAttachAccount: null,
            successIsOpen: false,
            errorMessage: "",
        }
        this.GetInformation = this.GetInformation.bind(this);
        this. CreateMainContact = this. CreateMainContact.bind(this);
        this.AttachPersonalAccount = this.AttachPersonalAccount.bind(this);


        this.apiAccountManagerRequest = new AccountManagerRequests();
        this.apiSettingRequest = new SettingRequests();

    }

    private apiAccountManagerRequest: AccountManagerRequests;
    private apiSettingRequest: SettingRequests;

    async componentDidMount() {
        this.apiSettingRequest.Init();
        await this.GetInformation();

    }

    componentWillUnmount(): void {
        this.apiSettingRequest.Abort();

    }

    private async GetInformation() {
        this.setState({
            isLoading: true
        })

        let result = await Promise.all([
            this.apiAccountManagerRequest.IsExistsMainContact(),
            this.apiSettingRequest.GetServiceObjectTypeNumber(),
            this.apiSettingRequest.GetServiceObjectTypeAttachAccount()

        ])




        if (result[0].result) {


            this.setState({
                isLoading: false,
                isExistsMainContact: result[0].data,
                serviceObjectTypeNumber: result[1].result ? result[1].data : null,
                serviceObjectTypeAttachAccount: result[2].result ? result[2].data : null,
            })

        }
        else {
            this.setState({
                isLoading: false
            })
            let notificationError: NotificationToast = {
                type: NotificationTypeEnum.danger,
                message: `Проверка возможности добавить ЛС. ${ApiResponseHelper.GetErrorMessage(result[0].error)}`,
                additionalMessage: ApiResponseHelper.GetErrorGuid(result[0].error)
            }
            ToastNotificationManager.SendToast(notificationError);
            setTimeout(() => {
                this.props.history.push(Navigation.GeneralPage)

            }, 5000);
            return;

        }

    }

    private async  CreateMainContact(command:  CreateMainContactCommand): Promise<void> {
        this.setState({
            isProgress: true
        })

        let resultCreateMainContact= await this.apiAccountManagerRequest. CreateMainContact(command)


        if (resultCreateMainContact.result) {


            this.setState({
                isProgress: false,
                isExistsMainContact: true,
            })

        }
        else {
            this.setState({
                isProgress: false
            })
            let notificationError: NotificationToast = {
                type: NotificationTypeEnum.danger,
                message: `Сохранение контактных данных. ${ApiResponseHelper.GetErrorMessage(resultCreateMainContact.error)}`,
                additionalMessage: ApiResponseHelper.GetErrorGuid(resultCreateMainContact.error)
            }
            ToastNotificationManager.SendToast(notificationError);

            return;

        }
    }

    private async AttachPersonalAccount(command: AttachPersonalAccountCommand): Promise<void> {
        this.setState({
            isProgress: true
        })

        let resultAttachPersonalAccount = await this.apiAccountManagerRequest.AttachPersonalAccount(command)
        if (resultAttachPersonalAccount.result) {
            this.setState({
                isProgress: false,
                successIsOpen: true,
            }, () => {
                if (resultAttachPersonalAccount.data !== null) {
                    this.props.AttachAccountAction(resultAttachPersonalAccount.data)
                }
            })

        }
        else {
            this.setState({
                isProgress: false,
                errorMessage: resultAttachPersonalAccount.error?.message || "Неизвестная ошибка"
            })
        }
    }

    private ParsePhoneNumperQuery(phoneString: string | null): string | null {
        if (phoneString == null) {
            return null;
        }
        else {
            let phone = PhoneParser.parsePhoneNumberFromString(phoneString || '', "RU");
            if (phone?.isValid() &&
                phone.country === "RU") {

                return phone.nationalNumber;
            }
            else {
                return null;
            }

        }
    }


    render(): React.ReactNode {
        return <React.Fragment>
            <Modal isOpen={this.props.attachIsOpen} onClose={() => this.props.SetAttachOpen(false)}>
                <div className='attach__close button' onClick={() => this.props.SetAttachOpen(false)}>
                    <CloseIcon />
                </div>
                {this.props.attachIsOpen &&
                    <AccountAttachForm
                        isProgress={this.state.isProgress}
                        serviceObjectTypeNumber={this.state.serviceObjectTypeNumber}
                        serviceObjectTypeAttachAccount={this.state.serviceObjectTypeAttachAccount}
                        AttachPersonalAccount={this.AttachPersonalAccount} />

                }
            </Modal>
            <Popup isOpen={this.state.successIsOpen} onClose={() => { this.props.SetAttachOpen(false); this.setState({ successIsOpen: false }) }}>
                <div className='info-popup'>
                    <div className='info-popup_wrapper'>
                        <div className='text-bold'>Готово!</div>
                        <div className='name-passive--8'>Добавление лицевого счета успешно выполнена</div>
                    </div>
                    <div className='info-popup_button button button-text'
                        onClick={() => { this.props.SetAttachOpen(false); this.setState({ successIsOpen: false }) }}>Закрыть</div>
                </div>
            </Popup>
            <Popup isOpen={this.state.errorMessage !== ""} onClose={() => { this.props.SetAttachOpen(false); this.setState({ errorMessage: "" }) }}>
                <div className='info-popup'>
                    <div className='info-popup_wrapper'>
                        <div className='text-bold'>Ошибка добавления лицевого счета</div>
                        <div className='name-passive--8'>{this.state.errorMessage}</div>
                    </div>
                    <div className='info-popup_button red button button-text'
                        onClick={() => { this.setState({ errorMessage: "" }) }}>Закрыть</div>
                </div>
            </Popup>


        </React.Fragment>

    }

}


export default connect(
    (state: ApplicationState) => ({ attachIsOpen: state.AccountState?.attachIsOpen }),
    dispatchAction
)(AccountAttach as any);
